// removed by extract-text-webpack-plugin
module.exports = {"EpisodeListItem":"_1KHgPYkIouqxbQOaed43aE","Title":"_3jCcI857HlfduR74Dz9oef","Duration":"_3BPhg2_fn9stXcniQfKLkx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/EpisodeListItem/EpisodeListItem.css
// module id = 675
// module chunks = 0